/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Req_TitleInputs */

const en_wc_on_req_title = /** @type {(inputs: Wc_On_Req_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you need`)
};

/**
* | output |
* | --- |
* | "What you need" |
*
* @param {Wc_On_Req_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_req_title = /** @type {((inputs?: Wc_On_Req_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Req_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_req_title(inputs)
});
export { wc_on_req_title as "wc.on.req_title" }